module.exports = __webpack_public_path__ + "static/media/logo-reducce.4ff86e29.png";